export const CASE_NUMBER_LOOKUP_URL = 'https://services.flhsmv.gov/DLCheck/';
